import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ContactFormRequest } from "./contact-form.model";

@Injectable({
  providedIn: "root",
})
export class ContactFormService {
  baseUrl = "https://hooks.zapier.com/hooks/catch/23844768/u2qwzlt";

  constructor(private http: HttpClient) {}

  public sendMail(data: ContactFormRequest) {
    // Only include non-empty parameters
    const payload: any = {};
    if (data.email) payload.email = data.email;
    if (data.message) payload.message = data.message;
    if (data.phone) payload.phoneNumber = data.phone;
    if (data.name) payload.name = data.name;

    // We send this as text/plain so it qualifies as a "simple request" in the browser,
    // which bypasses the CORS preflight (OPTIONS) request entirely.
    // Zapier's webhook will still parse the JSON string correctly.
    const headers = new HttpHeaders({ 'Content-Type': 'text/plain; charset=utf-8' });
    return this.http.post<boolean>(this.baseUrl, JSON.stringify(payload), { headers });
  }
}
